import styled from 'styled-components';

export const Input = styled.input`
  width: 100%;
  height: 50px;
  padding-left: 10px;
  background-color: #F3F3F3;
  border-radius: 8px;
  outline: ${props => props.hidden ? 'none' : null}
`;
